export default __webpack_public_path__ + "static/media/a001-04.5f8f473f.svg";